import {BENEFITS_BRANDS} from 'constants/uhc';
import {useHostSelector} from 'hooks/hostHooks/hostHooks';
import {getRouting} from 'selectors/routing';

/**
 * Custom hook to determine if the current page is a UHC page.
 * @returns {{ isUhcPage: boolean }} Object containing a boolean value indicating if the current page is a UHC page.
 */
export const useIsUhcPage = () => {
    const {location} = useHostSelector(store => getRouting(store));
    const isUhcPage =
        Boolean(location) &&
        Object.values(BENEFITS_BRANDS)
            .map(({url}) => url)
            .includes(location?.pathname);

    return {
        isUhcPage,
    };
};
